import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  RepairSparePartDto,
  RepairSparePartFullReferenceDto,
  RepairSparePartReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import RepairSparePartInline, { RepairSparePartInlineProps } from "./RepairSparePartInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity:
    | RepairSparePartDto
    | RepairSparePartReferenceDto
    | RepairSparePartFullReferenceDto
    | null
    | undefined;
  entityId?: string | null;
  inlineProps?: Partial<RepairSparePartInlineProps>;
}

export default function RepairSparePartLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.RepairCatalogRead]}
      to={ROUTE_PATH.REPAIR_SPARE_PART_VIEW(entity?.id || entityId || "")}
      content={<RepairSparePartInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
